import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Button, Paper } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ToastContainer } from "react-toastify";
import Typography from "@mui/material/Typography";

function AboutUs(props) {
  return (
    <Grid container sx={{ textAlign: "justify", height: "100vh" }}>
      <Paper
        sx={{
          m: 1,
          // height:"70%",
          width: "90%",
          borderRadius: " 15px",
          fontWeight: "bold",
          p: 1,
          border: 2,
          borderColor: "secondary.main",
          // backgroundColor: "#e5b7b74a",
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "1.3rem" }}>
          اوملنگ از کجا شروع شد؟
        </Typography>
        <Typography>
          یکی از روشهای تقویت زبان که امروزه بین زبان آموزان بسیار محبوب شده
          استفاده از فیلم و سریال است، اما این روش چالشهایی دارد که اوملنگ با
          ایده رفع این چالش ها طراحی شد. بعبارتی میزان اثرگذاری یادگیری زبان با
          فیم وابسته به رعایت یک سری روش و اصول است که اجرای آنها با پلیر های
          معمولی کمی سخت است.
        </Typography>
        <Typography>
          در پایین برخی از نکات یادگیری زبان با فیلم را نوشته ایم و در انتها به
          چالش اجرای آن با ویدیوپلیر معمولی اشاره کرده ایم
        </Typography>
        <Typography sx={{ fontWeight: "bold" }}>
          1- تماشای فیلم با دو، یک و بدون زیرنویس
        </Typography>
        <Typography>
          با توجه به سطح خودتان ، فیلم ها را دفعه اول با دو زیرنویس، دفعه دوم
          فقط با زیرنویس انگلیسی، و در نهایت بدون زیرنویس تماشا کنید. چالش: اگر
          با پلیرها آشنا باشید،ممکن است تماشای فیلم با دو زیرنویس و یا دیگر حالت
          ها برای شما سخت نباشد،اما کنترل سریع وضعیت نمایش زیرنویس به آسانی
          انجام نمیشود.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          2- کلمات و عبارت‌های مفید را یادداشت کنید!
        </Typography>
        <Typography>
          کلمات پرتکرار و کلماتی که برای شما جذاب هستند و مناسب سطح شما می باشند
          را یادداشت کنید چالش: انجام اینکار نیازمند توقف پلیر و یادداشت لغت و
          عبارت است که اینکار علاوه بر اینکه زمان شما را میگیرد، ممکن است تمرکز
          شما را نیز بهم بزند.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          3- مشاهده و یادداشت ترجمه کلمات و اصطلاحات
        </Typography>
        <Typography>
          ترجمه کلماتی که در بخش قبل یادداشت کرده اید را از طریق دیکشنری پیدا
          نموده و یادداشت کنید چالش: پیدا نمودن ترجمه کلمات از دیکشنری و یادداشت
          برداری از آنها کاری زمان بر است و ممکن است باعث خستگی زبان آموز شود.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          4- از تکنیک سایه استفاده کنید
        </Typography>
        <Typography>
          حتما از تکنیک سایه استفاده کنید، تقلید و تکرار دیالوگ‌های شخصیت‌ها در
          یادگیری زبان تاثیر فراوانی دارد و در هنگام تکرار، بر روی اصوات، هجاها
          و نحوه بیان و تلفظ کلمات و اصطلاحات تمرکز کنید. چالش: برای اجرای صحیح
          این تکنیک نیاز است که شما قسمت هایی از فیلم را چندین بار و به صورت های
          مختلف (با متن و بدون متن، با ولوم بالا و ولوم پایین، با سرعت معمولی و
          آهسته و ...) تماشا کنید که انجام اینکار با پلیر معمولی واقعا اذیت
          کننده است.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          5- یادداشت کردن نمونه کاربرد کلمه در جملات
        </Typography>
        <Typography>
          پس از یادداشت برداری و پیدا نمودن معنی کلمه، بهتر است چند نمونه از
          کاربرد کلمات در جملات نیز یادداشت شود چالش: پیدا نمودن جملات کاربردی
          مناسب که در آنها از کلمه مورد نظر شما استفاده شده کمی دشوار است.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          6- انتخاب فیلم مناسب
        </Typography>
        <Typography>
          تماشای فیلم یا سریالی که به آن علاقه دارید، به دلیل اینکه باعث ترشح
          هورمون سروتونین در بدن می‌شود، یادگیری زبان را برای شما تسهیل می‌سازد
          و این مسئله امروزه، به عنوان یک نکته مثبت در نظر گرفته می‌شود. چالش:
          برنامه هایی که برای یادگیری با فیلم وجود دارند ، محدود به چند فیلم
          مانند فرندز و انیمیشن و ... هستند.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          7- مرور لغات و اصطلاحات یادداشت شده
        </Typography>
        <Typography>
          پس از یادداشت لغات و اصطلاحات آنها را به فلش کارت منتقل نموده و از
          طریق فلش کارت لغات را فراگیرید. چالش: با وجود ابزارهایی مثل انکی و
          دیگر فلش کارت ها، مرور لغات کار سختی نیست،اما اگر با انکی و دیگر فلش
          کارتها کار کرده اید حتما برای ورد کلمات و اصطلاحات به درون آن زمان
          زیادی را صرف کرده اید.
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>
          8- کلمات مناسب سطح خودتان را یاد بگیرید
        </Typography>
        <Typography>
          هر لغت در هر زبانی دارای سطح مشخصی است (CEFR Levels) که بهتر است شما
          نیز لغاتی که مناسب سطح خودتان است را فراگیرد. چالش: تشخیص سطح لغات کار
          آسانی نیست، البته برخی از دیکشنری ها سطح لغات را نشان میدهند ولی
          جستجوی تمام لغات در دیکشنری کار آسانی نیست.
        </Typography>

        <Typography sx={{ fontWeight: "bold", fontSize: "1.3rem" }}>
          با اوملنگ ما اومدیم که چالش های بالا رو حل کنیم
        </Typography>
        <Typography>
          ا تکنیکهای کاربردی گفته شده در بالا به خوبی میتونین زبان خودتون رو
          تقویت کرد، ولی همانطور که اشاره شده چالشهایی داره. اپلیکشن اوملنگ
          تمامی تکنیکهای پیشنهاد شده رو پیاده سازی کرده و علاوه بر حل چالشهای
          مطرح شده، برخی امکانات دیگه هم برای یادگیری بهتر فراهم کرده که آموزش
          مفصل کار با هر یک از این فیچرها درون برنامه بیان شده است
        </Typography>

        <Typography sx={{ fontWeight: "bold" }}>امکانات اوملنگ:</Typography>
        <Typography>- نمایش دو زیرنویس همزمان</Typography>
        <Typography>- دیکشنری پاپ آپ</Typography>
        <Typography>- ذخیره سریع</Typography>
        <Typography>- ذخیره پیشرفته لغات واصطلاحات</Typography>
        <Typography>- مرور لغات به روش SRS در لایتنر</Typography>
        <Typography>
          - امکان مشاهده ترجمه،تلفظ ، نمونه کاربرد و ... با استفاده از بهترین
          دیکشنری های آنلاین
        </Typography>
        <Typography>
          - اجرای آسان تکنیک محبوب و کاربردی سایه (Shadowing)
        </Typography>
        <Typography>- هایلایت لغات در حال یادگیری</Typography>
        <Typography>- هایلایت لغات سخت</Typography>
        <Typography>
          - هایلایت لغات بر اساس سطح بندی استاندارد (CEFR) ( در نسخه اولیه
          برنامه زبان انگیسی پشتیبانی می شود)
        </Typography>
        <Typography>- تغییر بک گراند لغات درحال یادگیری</Typography>
        <Typography>- تغییر بک گراند لغات سخت</Typography>
        <Typography>
          - تغییر بک گراند بر اساس سطح بندی استاندارد (CEFR) (زبان انگیسی)
        </Typography>
        <Typography>
          - توقف فیلم به مدت دلخواه در صورت وجود کلمات آماده مرور
        </Typography>
        <Typography>
          - توقف فیلم به مدت دلخواه در صورت وجود کلمات سخت
        </Typography>
        <Typography>
          - توقف فیلم به مدت دلخواه در صورت وجود کلمات سطح بندی شده (CEFR) (زبان
          انگیسی)
        </Typography>
        <Typography>
          - تکرار دیالوگ به دفعات قابل تنظیم در صورت وجود کلمات آماده مرور
        </Typography>
        <Typography>
          - تکرار دیالوگ به دفعات قابل تنظیم در صورت وجود کلمات سخت
        </Typography>
        <Typography>
          - تکرار دیالوگ به دفعات قابل تنظیم در صورت وجود کلمات سطح بندی شده
          (CEFR) (زبان انگیسی)
        </Typography>
        <Typography>
          - عدم وابستگی به سرعت اینترنت ( اول فیلمو با خیال راحت دانلود کن بعدا
          بدون دغدغه تماشاش کن و زبان یاد بگیر)
        </Typography>
        <Typography>- امکان هماهنگ سازی زیرنویس ها</Typography>
        <Typography>- تغییر فونت زیرنویس اول و دوم</Typography>
        <Typography>- تغییر رنگ زیرنویس اول و دوم</Typography>
        <Typography>- تغییر بک گراند زیرنویس اول و دوم</Typography>
        <Typography>- ابجایی آسان زیرنویس اول و دوم</Typography>
        <Typography>- اجرای تکنیک سایه(نسخه موبایل)</Typography>
        <Typography>
          - امکان مشاهده بروز ترین فیلم ها و سریال های دنیا
        </Typography>
      </Paper>
    </Grid>
  );
}

export default AboutUs;
